import React from 'react';
import { Button } from '@syneto/compass-react';

/*
 * The way from a tier to the license it belongs to, for whoever finds the tier itself wrong (its
 * value and unit are the license form's, not this page's). It sits in its own column, as the row
 * actions of the app's tables do, so the tier reads on one line.
 *
 * Only offered when the caller gives a handler, and only for a license the catalog knows, since
 * the license form would have nothing to show otherwise.
 */
const EditLicenseAction = (props) => {
	const { row, onEditLicense } = props;

	if (!onEditLicense || !row.licenseKnown) {
		return null;
	}

	return (
		<Button role="tertiary" className="m-0" onClick={() => { return onEditLicense(row.licenseId); }}>
			Edit license
		</Button>
	);
};

export default EditLicenseAction;
